import { createSelector } from '@ngrx/store';

import { type EngineStateBase } from '@blaze-runtime/engine-data-access';

import { type AiUndoState } from '../../ai/chat/ai-undo.service';
import { getEngineState } from '../engine';

export const selectAIState = createSelector(getEngineState, (state) => state.ai);

export const selectUpdatedBindings = createSelector(
  selectAIState,
  (state) => state.updatedBindings,
);

export const selectGenerateDialogs = createSelector(
  selectAIState,
  (state) => state.generateDialogs,
);

export const selectGenerateDeleteRowActions = createSelector(
  selectAIState,
  (state) => state.generateDeleteRowActions,
);

export const selectUpdatedCharts = createSelector(
  selectAIState, //
  (state) => state.updatedCharts,
);

export const selectGenerateRowClickActions = createSelector(
  selectAIState,
  (state) => state.generateRowClickActions,
);

export const selectUpdatedWorkflows = createSelector(
  selectAIState, //
  (state) => state.updatedWorkflows,
);

export const selectUndoState = createSelector(getEngineState, (state) => createUndoState(state));

export const selectElementsMap = createSelector(selectAIState, (state) => state.elementsMap);

export const selectAiExecutionError = createSelector(selectAIState, (state) => state.error);

export function createUndoState(state: EngineStateBase): AiUndoState {
  return {
    ids: state.ids,
    entities: state.entities,
    connections: state.connections,
    schemas: state.schemas,
    workflows: state.workflows,
  };
}
